import { is } from 'ramda'
import type { CustomEventsContext } from '../types'

export const CONTACTS_ACCESS_DECLINED = 'Contacts Access Declined'

export default function (this: CustomEventsContext) {
  return this.sendEventWithCallback('contacts.list', {})
    .then((data: unknown) => {
      const d = data as { contacts?: unknown }
      if (is(Object, d.contacts)) {
        return data
      }
      return Promise.reject(new Error(
        (d.contacts === false)
          ? CONTACTS_ACCESS_DECLINED
          : this.ERROR_UNKNOWN
      ))
    })
}
